module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/9c60c52171ecefef2ef4d9d63b71ad55.png";